// Code generated by scripts/i18nstringsgen. DO NOT EDIT.

export type Lang = "ru";

/** The form of a counted noun. A language with no rule of its own gets the
 * English one/other shape out of one and many. */
export function plural(lang: Lang, n: number, one: string, few: string, many: string): string {
  const abs = Math.abs(n);
  if (lang === "ru") {
    const rest = abs % 100;
    if (rest >= 11 && rest <= 14) return many;
    const last = abs % 10;
    if (last === 1) return one;
    if (last >= 2 && last <= 4) return few;
    return many;
  }
  return abs === 1 ? one : many;
}
